import { safeWindow } from "framer-motion"

/** @internal */
export function debounce<T extends any[]>(fn: (...args: T) => void, time: number): (...args: T) => void {
    let timeout: number | undefined
    return (...args: T) => {
        safeWindow.clearTimeout(timeout)
        timeout = safeWindow.setTimeout(fn, time, ...args)
    }
}
